import {useEffect, useState} from 'react';
import LogoMain from '../../assets/logoMain';
import { Col } from 'reactstrap'
import './index.scss'
import UserIcon from './UserIcon';
import Help from './Help';
import CommonModal from '../CommonModal';
import { CloseOutlined } from "@material-ui/icons";
import MailOutlineIcon from '@material-ui/icons/MailOutline';
import WhatsAppIcon from '@material-ui/icons/WhatsApp';
import { EmailShareButton } from 'react-share';
import { IconButton } from '@material-ui/core';
import LinkIcon from '@material-ui/icons/Link';
import { useLocation } from 'react-router-dom';
import { SSO_auth_path } from '../../config';
import { getFromLocalStorage } from '../../utils/Helpers';
import ButtonCommon from '../ButtonCommon';

const Header = ({props}) => {
  const [modal, setModal] = useState(false);
  const [link, setLink] = useState(window.location.href);
  const [copied, setCopied] = useState(false);
  const location = useLocation();
  const [scrollPosition, setScrollPosition] = useState(0);
  const token = getFromLocalStorage("token");

  const handleScroll = () => {
    const position = window.pageYOffset;
    setScrollPosition(position);
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => {
        window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const renderShareLink = () => {
    if (window.location.pathname !== '/' && window.location.pathname !== '/home') {
      return <li className="UserIconCon">
        <IconButton
          onClick={() => setModal(true)}
          className="headerMenu"
        >
          <LinkIcon />
          <span>Share</span>
        </IconButton>
      </li>
    }
  }

  const renderMessage = () => {
    return `I have initiated a loan application for the ClearTax GST PayLater credit line wherein ClearTax’s associated lenders will pay GST taxes. There are a few steps I’d like you to complete. Use this link and login with email and password to complete the steps. ${link}`
  }

  const copyLink = () => {
    navigator.clipboard.writeText(link);
    setCopied(true);
    setTimeout(() => {
      setCopied(false);
    }, 2000);
  }

  const applyNow = () => {
    let stingToConvert = '/verification'
    const urlParams = new URLSearchParams(window.location.search);
    const partnerToken = urlParams.get('token');
    if (partnerToken) {
      stingToConvert += '?token='+partnerToken;
    }
    let redirectUrl = btoa(stingToConvert)
    //logout();

    window.location.href = `${SSO_auth_path}&return_path=${redirectUrl}`;
  }

  const renderLoginButton = () => {
    if (!token) {
      return <button className="loginBtn" onClick={() => applyNow()}>Login</button>  
    }
  }

  return (
    <div className={scrollPosition > 500 && !token ? "header mainHeader" : "header"}>
      <div className="headerInner">
        <Col lg={4}  md={4} xs={4} className="headerLogo" onClick={() => props.history.push({pathname: '/home', search: location.search})}>
          <LogoMain />
        </Col>
        <Col lg={8} md={8} xs={8} className={scrollPosition > 500 && !token? "headerLeftMenuCon modifyHeader" : "headerLeftMenuCon"}>
          <ul className="headerMenu headerLeftMenu">
            {renderShareLink()}
            <li className="UserIconCon">
              <Help />
            </li>
            <li className="UserIconCon">
              <UserIcon />
            </li>
            <li>
              {renderLoginButton()}
              <span className="applyCon">
                <ButtonCommon className="applyBtn" title="Check Eligibility" onClick={() => applyNow()} />
              </span>
            </li>
          </ul>
        </Col>

        <CommonModal className="confirmationModal" open={modal} maxWidth="md">
          <div onClick={() => {setModal(false)}} className="modalCloseBtn">
            <CloseOutlined />
          </div>
          <div className="modalHeading">
            <h4>Do you want to share application link with someone to complete few steps?</h4>
            <ul>
              <li>Copy and share the below link with them</li>
              <li>They can login with the applicant email ID to continue</li>
            </ul>
          </div>
          <div className="copyBox">
            <div className="copyForm">
              <span className="attachment"><img src="LinkSimple.png" /></span>
              <input disabled value={link} className="form-control" type="text" />
              <button className={copied && 'copied'} onClick={() => copyLink()}>{copied ? 'Link Copied!' : 'Copy Link'}</button>
            </div>
            <div className="copyDiv">
              <span>or</span>
            </div>
            <div className="copyFooter">
              <div className="headingBox">
                Share via whatsapp or email
              </div>
              <div className="copyButtons">
                <a href={`https://api.whatsapp.com/send?text=${renderMessage()}`} target="_blank">
                  <WhatsAppIcon />
                </a>
                <EmailShareButton url={renderMessage()}>
                  <MailOutlineIcon />
                </EmailShareButton>
              </div>
            </div>
          </div>
        </CommonModal>
      </div>
    </div>
  );
}
export default Header